<template>
    <div class="library-qa-status-filter">
        <collapsible-widget>
            <template #name>Other Filters</template>

            <CheckboxGroup v-model="miscFilters">
                <Checkbox :label="FilterGroup.HideDuplicates">Hide Duplicates</Checkbox>
            </CheckboxGroup>
        </collapsible-widget>
    </div>
</template>

<script lang="ts">
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { DeliverableLibraryAction, DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";

export default {
    name: "LibraryMiscFilter",
    components: {
        CollapsibleWidget
    },

    data() {
        return {
            FilterGroup: {
                HideDuplicates: "dedup"
            }
        };
    },

    computed: {
        miscFilters: {
            get() {
                return this.$store.getters[DeliverableLibraryGetters.miscFilters];
            },
            set(value: string) {
                this.$store.dispatch(DeliverableLibraryAction.UpdateMiscFilter, value);
            }
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-qa-status-filter {
    .ivu-radio {
        margin: 0;
    }

    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        margin: 0;
        padding: 0 0 0 50px;
        display: block;
    }
}

.library-qa-status-filter__status-dot-wrapper {
    display: inline-block;
    padding: 0 0 0 $spacing-smaller;
}
</style>
